// import s from "./ErrorMessage.module.scss";

export const ErrorMessage: React.FC<{ message?: string }> = ({ message }) => {
  if (!message) return null;
  return (
    <p style={{ color: "red", fontSize: "12px", fontWeight: "300" }}>
      {message}
    </p>
  );
};
